/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfCheckIsResendByAutomaticResendDto } from '../models/custom-result-of-check-is-resend-by-automatic-resend-dto';
import { CustomResultOfCheckOutboxMessagesIsResendByAutomaticResendDto } from '../models/custom-result-of-check-outbox-messages-is-resend-by-automatic-resend-dto';
import { CustomResultOfGetOutBoxByScheduledIdDto } from '../models/custom-result-of-get-out-box-by-scheduled-id-dto';
import { CustomResultOfGetOutBoxMessageAndBulkRecipientsByIdDto } from '../models/custom-result-of-get-out-box-message-and-bulk-recipients-by-id-dto';
import { CustomResultOfGetOutBoxMessagesByResellerIdDto } from '../models/custom-result-of-get-out-box-messages-by-reseller-id-dto';
import { CustomResultOfGetResendCalculationDto } from '../models/custom-result-of-get-resend-calculation-dto';
import { CustomResultOfListOfGetLastLimitedCurrentUserOutboxMessagesDto } from '../models/custom-result-of-list-of-get-last-limited-current-user-outbox-messages-dto';
import { CustomResultOfListOfGetOutboxMessageTransactionsDto } from '../models/custom-result-of-list-of-get-outbox-message-transactions-dto';
import { CustomResultOfListOfOutBoxMessageDailyCategorizedStatisticsDto } from '../models/custom-result-of-list-of-out-box-message-daily-categorized-statistics-dto';
import { CustomResultOfListOfOutBoxMessagesStatisticsDto } from '../models/custom-result-of-list-of-out-box-messages-statistics-dto';
import { CustomResultOfListOfSendTypeStatisticsByDateTimeDto } from '../models/custom-result-of-list-of-send-type-statistics-by-date-time-dto';
import { CustomResultOfListOfSendTypeStatisticsDto } from '../models/custom-result-of-list-of-send-type-statistics-dto';
import { CustomResultOfOutboxMessagePaginatedListOfGetCurrentUserWithPaginationDto } from '../models/custom-result-of-outbox-message-paginated-list-of-get-current-user-with-pagination-dto';
import { CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto } from '../models/custom-result-of-outbox-message-paginated-list-of-get-outbox-messages-with-pagination-dto';
import { CustomResultOfOutboxMessagePaginatedListOfResellerOutBoxMessagesWithPaginationDto } from '../models/custom-result-of-outbox-message-paginated-list-of-reseller-out-box-messages-with-pagination-dto';
import { CustomResultOfTotalReceiversCountAndTotalPricesQueryDto } from '../models/custom-result-of-total-receivers-count-and-total-prices-query-dto';
import { outBoxMessagesCheckIsResendByAutomaticResend } from '../fn/out-box-messages/out-box-messages-check-is-resend-by-automatic-resend';
import { OutBoxMessagesCheckIsResendByAutomaticResend$Params } from '../fn/out-box-messages/out-box-messages-check-is-resend-by-automatic-resend';
import { outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend } from '../fn/out-box-messages/out-box-messages-check-outbox-messages-is-resend-by-automatic-resend';
import { OutBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend$Params } from '../fn/out-box-messages/out-box-messages-check-outbox-messages-is-resend-by-automatic-resend';
import { outBoxMessagesDeleteOutBoxMessage } from '../fn/out-box-messages/out-box-messages-delete-out-box-message';
import { OutBoxMessagesDeleteOutBoxMessage$Params } from '../fn/out-box-messages/out-box-messages-delete-out-box-message';
import { outBoxMessagesDeleteOutBoxMessagesByList } from '../fn/out-box-messages/out-box-messages-delete-out-box-messages-by-list';
import { OutBoxMessagesDeleteOutBoxMessagesByList$Params } from '../fn/out-box-messages/out-box-messages-delete-out-box-messages-by-list';
import { outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices } from '../fn/out-box-messages/out-box-messages-get-current-user-out-box-messages-total-receivers-count-total-prices';
import { OutBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices$Params } from '../fn/out-box-messages/out-box-messages-get-current-user-out-box-messages-total-receivers-count-total-prices';
import { outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination } from '../fn/out-box-messages/out-box-messages-get-current-user-out-box-messages-with-pagination';
import { OutBoxMessagesGetCurrentUserOutBoxMessagesWithPagination$Params } from '../fn/out-box-messages/out-box-messages-get-current-user-out-box-messages-with-pagination';
import { outBoxMessagesGetLastLimitedCurrentUserOutboxMessages } from '../fn/out-box-messages/out-box-messages-get-last-limited-current-user-outbox-messages';
import { OutBoxMessagesGetLastLimitedCurrentUserOutboxMessages$Params } from '../fn/out-box-messages/out-box-messages-get-last-limited-current-user-outbox-messages';
import { outBoxMessagesGetOutBoxMessageAndBulkRecipientsById } from '../fn/out-box-messages/out-box-messages-get-out-box-message-and-bulk-recipients-by-id';
import { OutBoxMessagesGetOutBoxMessageAndBulkRecipientsById$Params } from '../fn/out-box-messages/out-box-messages-get-out-box-message-and-bulk-recipients-by-id';
import { outBoxMessagesGetOutboxMessageByScheduledMessageId } from '../fn/out-box-messages/out-box-messages-get-outbox-message-by-scheduled-message-id';
import { OutBoxMessagesGetOutboxMessageByScheduledMessageId$Params } from '../fn/out-box-messages/out-box-messages-get-outbox-message-by-scheduled-message-id';
import { outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics } from '../fn/out-box-messages/out-box-messages-get-out-box-message-categorized-daily-statistics';
import { OutBoxMessagesGetOutBoxMessageCategorizedDailyStatistics$Params } from '../fn/out-box-messages/out-box-messages-get-out-box-message-categorized-daily-statistics';
import { outBoxMessagesGetOutBoxMessageDailyStatistics } from '../fn/out-box-messages/out-box-messages-get-out-box-message-daily-statistics';
import { OutBoxMessagesGetOutBoxMessageDailyStatistics$Params } from '../fn/out-box-messages/out-box-messages-get-out-box-message-daily-statistics';
import { outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination } from '../fn/out-box-messages/out-box-messages-get-out-box-messages-by-reseller-id-with-pagination';
import { OutBoxMessagesGetOutBoxMessagesByResellerIdWithPagination$Params } from '../fn/out-box-messages/out-box-messages-get-out-box-messages-by-reseller-id-with-pagination';
import { outBoxMessagesGetOutboxMessageTransactions } from '../fn/out-box-messages/out-box-messages-get-outbox-message-transactions';
import { OutBoxMessagesGetOutboxMessageTransactions$Params } from '../fn/out-box-messages/out-box-messages-get-outbox-message-transactions';
import { outBoxMessagesGetOutBoxStatisticsByDateTime } from '../fn/out-box-messages/out-box-messages-get-out-box-statistics-by-date-time';
import { OutBoxMessagesGetOutBoxStatisticsByDateTime$Params } from '../fn/out-box-messages/out-box-messages-get-out-box-statistics-by-date-time';
import { outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices } from '../fn/out-box-messages/out-box-messages-get-reseller-out-box-messages-total-receivers-count-total-prices';
import { OutBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices$Params } from '../fn/out-box-messages/out-box-messages-get-reseller-out-box-messages-total-receivers-count-total-prices';
import { outBoxMessagesGetResellerOutBoxMessageWithPagination } from '../fn/out-box-messages/out-box-messages-get-reseller-out-box-message-with-pagination';
import { OutBoxMessagesGetResellerOutBoxMessageWithPagination$Params } from '../fn/out-box-messages/out-box-messages-get-reseller-out-box-message-with-pagination';
import { outBoxMessagesGetResendCalculation } from '../fn/out-box-messages/out-box-messages-get-resend-calculation';
import { OutBoxMessagesGetResendCalculation$Params } from '../fn/out-box-messages/out-box-messages-get-resend-calculation';
import { outBoxMessagesGetScheduledMessageStatisticsByOrganizationId } from '../fn/out-box-messages/out-box-messages-get-scheduled-message-statistics-by-organization-id';
import { OutBoxMessagesGetScheduledMessageStatisticsByOrganizationId$Params } from '../fn/out-box-messages/out-box-messages-get-scheduled-message-statistics-by-organization-id';
import { outBoxMessagesGetUserOutBoxMessagesAuditWithPagination } from '../fn/out-box-messages/out-box-messages-get-user-out-box-messages-audit-with-pagination';
import { OutBoxMessagesGetUserOutBoxMessagesAuditWithPagination$Params } from '../fn/out-box-messages/out-box-messages-get-user-out-box-messages-audit-with-pagination';
import { outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices } from '../fn/out-box-messages/out-box-messages-get-user-out-box-messages-total-receivers-count-total-prices';
import { OutBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices$Params } from '../fn/out-box-messages/out-box-messages-get-user-out-box-messages-total-receivers-count-total-prices';
import { outBoxMessagesGetUserOutBoxMessagesWithPagination } from '../fn/out-box-messages/out-box-messages-get-user-out-box-messages-with-pagination';
import { OutBoxMessagesGetUserOutBoxMessagesWithPagination$Params } from '../fn/out-box-messages/out-box-messages-get-user-out-box-messages-with-pagination';
import { outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices } from '../fn/out-box-messages/out-box-messages-get-users-out-box-messages-total-receivers-count-total-prices';
import { OutBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices$Params } from '../fn/out-box-messages/out-box-messages-get-users-out-box-messages-total-receivers-count-total-prices';
import { outBoxMessagesGetUsersOutBoxMessagesWithPagination } from '../fn/out-box-messages/out-box-messages-get-users-out-box-messages-with-pagination';
import { OutBoxMessagesGetUsersOutBoxMessagesWithPagination$Params } from '../fn/out-box-messages/out-box-messages-get-users-out-box-messages-with-pagination';
import { outBoxMessagesResendByDeliveryStatusGet } from '../fn/out-box-messages/out-box-messages-resend-by-delivery-status-get';
import { OutBoxMessagesResendByDeliveryStatusGet$Params } from '../fn/out-box-messages/out-box-messages-resend-by-delivery-status-get';
import { outBoxMessagesResendByDeliveryStatusPost } from '../fn/out-box-messages/out-box-messages-resend-by-delivery-status-post';
import { OutBoxMessagesResendByDeliveryStatusPost$Params } from '../fn/out-box-messages/out-box-messages-resend-by-delivery-status-post';
import { outBoxMessagesResendDynamicByDeliveryStatusGet } from '../fn/out-box-messages/out-box-messages-resend-dynamic-by-delivery-status-get';
import { OutBoxMessagesResendDynamicByDeliveryStatusGet$Params } from '../fn/out-box-messages/out-box-messages-resend-dynamic-by-delivery-status-get';
import { outBoxMessagesResendDynamicByDeliveryStatusPost } from '../fn/out-box-messages/out-box-messages-resend-dynamic-by-delivery-status-post';
import { OutBoxMessagesResendDynamicByDeliveryStatusPost$Params } from '../fn/out-box-messages/out-box-messages-resend-dynamic-by-delivery-status-post';
import { outBoxMessagesResendDynamicOutBoxMessageGet } from '../fn/out-box-messages/out-box-messages-resend-dynamic-out-box-message-get';
import { OutBoxMessagesResendDynamicOutBoxMessageGet$Params } from '../fn/out-box-messages/out-box-messages-resend-dynamic-out-box-message-get';
import { outBoxMessagesResendDynamicOutBoxMessagePost } from '../fn/out-box-messages/out-box-messages-resend-dynamic-out-box-message-post';
import { OutBoxMessagesResendDynamicOutBoxMessagePost$Params } from '../fn/out-box-messages/out-box-messages-resend-dynamic-out-box-message-post';
import { outBoxMessagesResendOutBoxMessageGet } from '../fn/out-box-messages/out-box-messages-resend-out-box-message-get';
import { OutBoxMessagesResendOutBoxMessageGet$Params } from '../fn/out-box-messages/out-box-messages-resend-out-box-message-get';
import { outBoxMessagesResendOutBoxMessagePost } from '../fn/out-box-messages/out-box-messages-resend-out-box-message-post';
import { OutBoxMessagesResendOutBoxMessagePost$Params } from '../fn/out-box-messages/out-box-messages-resend-out-box-message-post';
import { outBoxMessagesStopSendingOutboxMessage } from '../fn/out-box-messages/out-box-messages-stop-sending-outbox-message';
import { OutBoxMessagesStopSendingOutboxMessage$Params } from '../fn/out-box-messages/out-box-messages-stop-sending-outbox-message';
import { outBoxMessagesUpdateDescription } from '../fn/out-box-messages/out-box-messages-update-description';
import { OutBoxMessagesUpdateDescription$Params } from '../fn/out-box-messages/out-box-messages-update-description';
import { outBoxMessagesUpdateIsShouldNotResendGet } from '../fn/out-box-messages/out-box-messages-update-is-should-not-resend-get';
import { OutBoxMessagesUpdateIsShouldNotResendGet$Params } from '../fn/out-box-messages/out-box-messages-update-is-should-not-resend-get';
import { outBoxMessagesUpdateIsShouldNotResendPut } from '../fn/out-box-messages/out-box-messages-update-is-should-not-resend-put';
import { OutBoxMessagesUpdateIsShouldNotResendPut$Params } from '../fn/out-box-messages/out-box-messages-update-is-should-not-resend-put';
import { outBoxMessagesUpdateStatusGet } from '../fn/out-box-messages/out-box-messages-update-status-get';
import { OutBoxMessagesUpdateStatusGet$Params } from '../fn/out-box-messages/out-box-messages-update-status-get';
import { outBoxMessagesUpdateStatusPut } from '../fn/out-box-messages/out-box-messages-update-status-put';
import { OutBoxMessagesUpdateStatusPut$Params } from '../fn/out-box-messages/out-box-messages-update-status-put';

@Injectable({ providedIn: 'root' })
export class OutBoxMessagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `outBoxMessagesGetUsersOutBoxMessagesWithPagination()` */
  static readonly OutBoxMessagesGetUsersOutBoxMessagesWithPaginationPath = '/OutBoxMessages/GetUsersOutBoxMessagesWithPagination';

  /**
   * Get OutBoxMessages Users with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetUsersOutBoxMessagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUsersOutBoxMessagesWithPagination$Response(params: OutBoxMessagesGetUsersOutBoxMessagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto>> {
    return outBoxMessagesGetUsersOutBoxMessagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBoxMessages Users with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetUsersOutBoxMessagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUsersOutBoxMessagesWithPagination(params: OutBoxMessagesGetUsersOutBoxMessagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto> {
    return this.outBoxMessagesGetUsersOutBoxMessagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto>): CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices()` */
  static readonly OutBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPricesPath = '/OutBoxMessages/GetUsersOutBoxMessagesTotalReceiversCountTotalPrices';

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق کاربران.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices$Response(params: OutBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>> {
    return outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق کاربران.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices(params: OutBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto> {
    return this.outBoxMessagesGetUsersOutBoxMessagesTotalReceiversCountTotalPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>): CustomResultOfTotalReceiversCountAndTotalPricesQueryDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetUserOutBoxMessagesWithPagination()` */
  static readonly OutBoxMessagesGetUserOutBoxMessagesWithPaginationPath = '/OutBoxMessages/GetUserOutBoxMessagesWithPagination';

  /**
   * Get OutBoxMessages User with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetUserOutBoxMessagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUserOutBoxMessagesWithPagination$Response(params: OutBoxMessagesGetUserOutBoxMessagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto>> {
    return outBoxMessagesGetUserOutBoxMessagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBoxMessages User with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetUserOutBoxMessagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUserOutBoxMessagesWithPagination(params: OutBoxMessagesGetUserOutBoxMessagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto> {
    return this.outBoxMessagesGetUserOutBoxMessagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto>): CustomResultOfOutboxMessagePaginatedListOfGetOutboxMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices()` */
  static readonly OutBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPricesPath = '/OutBoxMessages/GetUserOutBoxMessagesTotalReceiversCountTotalPrices';

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices$Response(params: OutBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>> {
    return outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices(params: OutBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto> {
    return this.outBoxMessagesGetUserOutBoxMessagesTotalReceiversCountTotalPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>): CustomResultOfTotalReceiversCountAndTotalPricesQueryDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination()` */
  static readonly OutBoxMessagesGetCurrentUserOutBoxMessagesWithPaginationPath = '/OutBoxMessages/GetCurrentUserOutBoxMessagesWithPagination';

  /**
   * Get OutBoxMessages Current User with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination$Response(params: OutBoxMessagesGetCurrentUserOutBoxMessagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfGetCurrentUserWithPaginationDto>> {
    return outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBoxMessages Current User with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination(params: OutBoxMessagesGetCurrentUserOutBoxMessagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfOutboxMessagePaginatedListOfGetCurrentUserWithPaginationDto> {
    return this.outBoxMessagesGetCurrentUserOutBoxMessagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfGetCurrentUserWithPaginationDto>): CustomResultOfOutboxMessagePaginatedListOfGetCurrentUserWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices()` */
  static readonly OutBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPricesPath = '/OutBoxMessages/GetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices';

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices$Response(params: OutBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>> {
    return outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices(params: OutBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto> {
    return this.outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>): CustomResultOfTotalReceiversCountAndTotalPricesQueryDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetResellerOutBoxMessageWithPagination()` */
  static readonly OutBoxMessagesGetResellerOutBoxMessageWithPaginationPath = '/OutBoxMessages/GetResellerOutBoxMessageWithPagination';

  /**
   * Get Reseller OutBox Messages With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetResellerOutBoxMessageWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetResellerOutBoxMessageWithPagination$Response(params: OutBoxMessagesGetResellerOutBoxMessageWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfResellerOutBoxMessagesWithPaginationDto>> {
    return outBoxMessagesGetResellerOutBoxMessageWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller OutBox Messages With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetResellerOutBoxMessageWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetResellerOutBoxMessageWithPagination(params: OutBoxMessagesGetResellerOutBoxMessageWithPagination$Params, context?: HttpContext): Observable<CustomResultOfOutboxMessagePaginatedListOfResellerOutBoxMessagesWithPaginationDto> {
    return this.outBoxMessagesGetResellerOutBoxMessageWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOutboxMessagePaginatedListOfResellerOutBoxMessagesWithPaginationDto>): CustomResultOfOutboxMessagePaginatedListOfResellerOutBoxMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices()` */
  static readonly OutBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPricesPath = '/OutBoxMessages/GetResellerOutBoxMessagesTotalReceiversCountTotalPrices';

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق فروشنده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices$Response(params: OutBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>> {
    return outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل گیرندگان و کل هزینه ارسال های صندوق فروشنده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices(params: OutBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices$Params, context?: HttpContext): Observable<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto> {
    return this.outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTotalReceiversCountAndTotalPricesQueryDto>): CustomResultOfTotalReceiversCountAndTotalPricesQueryDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination()` */
  static readonly OutBoxMessagesGetOutBoxMessagesByResellerIdWithPaginationPath = '/OutBoxMessages/GetOutBoxMessagesByResellerIdWithPagination';

  /**
   * Get OutBox Messages By Reseller Id With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination$Response(params: OutBoxMessagesGetOutBoxMessagesByResellerIdWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOutBoxMessagesByResellerIdDto>> {
    return outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBox Messages By Reseller Id With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination(params: OutBoxMessagesGetOutBoxMessagesByResellerIdWithPagination$Params, context?: HttpContext): Observable<CustomResultOfGetOutBoxMessagesByResellerIdDto> {
    return this.outBoxMessagesGetOutBoxMessagesByResellerIdWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOutBoxMessagesByResellerIdDto>): CustomResultOfGetOutBoxMessagesByResellerIdDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetUserOutBoxMessagesAuditWithPagination()` */
  static readonly OutBoxMessagesGetUserOutBoxMessagesAuditWithPaginationPath = '/OutBoxMessages/GetUserOutBoxMessagesAuditWithPagination';

  /**
   * Get OutBoxMessages User Audit with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetUserOutBoxMessagesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUserOutBoxMessagesAuditWithPagination$Response(params: OutBoxMessagesGetUserOutBoxMessagesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return outBoxMessagesGetUserOutBoxMessagesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBoxMessages User Audit with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetUserOutBoxMessagesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetUserOutBoxMessagesAuditWithPagination(params: OutBoxMessagesGetUserOutBoxMessagesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.outBoxMessagesGetUserOutBoxMessagesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendByDeliveryStatusGet()` */
  static readonly OutBoxMessagesResendByDeliveryStatusGetPath = '/OutBoxMessages/ResendByDeliveryStatus';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendByDeliveryStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendByDeliveryStatusGet$Response(params?: OutBoxMessagesResendByDeliveryStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outBoxMessagesResendByDeliveryStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendByDeliveryStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendByDeliveryStatusGet(params?: OutBoxMessagesResendByDeliveryStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outBoxMessagesResendByDeliveryStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendByDeliveryStatusPost()` */
  static readonly OutBoxMessagesResendByDeliveryStatusPostPath = '/OutBoxMessages/ResendByDeliveryStatus';

  /**
   * Resend by DeliveryStatus.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendByDeliveryStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendByDeliveryStatusPost$Response(params: OutBoxMessagesResendByDeliveryStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesResendByDeliveryStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Resend by DeliveryStatus.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendByDeliveryStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendByDeliveryStatusPost(params: OutBoxMessagesResendByDeliveryStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesResendByDeliveryStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendDynamicByDeliveryStatusGet()` */
  static readonly OutBoxMessagesResendDynamicByDeliveryStatusGetPath = '/OutBoxMessages/ResendDynamicByDeliveryStatus';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendDynamicByDeliveryStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendDynamicByDeliveryStatusGet$Response(params?: OutBoxMessagesResendDynamicByDeliveryStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outBoxMessagesResendDynamicByDeliveryStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendDynamicByDeliveryStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendDynamicByDeliveryStatusGet(params?: OutBoxMessagesResendDynamicByDeliveryStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outBoxMessagesResendDynamicByDeliveryStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendDynamicByDeliveryStatusPost()` */
  static readonly OutBoxMessagesResendDynamicByDeliveryStatusPostPath = '/OutBoxMessages/ResendDynamicByDeliveryStatus';

  /**
   * Resend Dynamic by DeliveryStatus.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendDynamicByDeliveryStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendDynamicByDeliveryStatusPost$Response(params: OutBoxMessagesResendDynamicByDeliveryStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesResendDynamicByDeliveryStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Resend Dynamic by DeliveryStatus.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendDynamicByDeliveryStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendDynamicByDeliveryStatusPost(params: OutBoxMessagesResendDynamicByDeliveryStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesResendDynamicByDeliveryStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendOutBoxMessageGet()` */
  static readonly OutBoxMessagesResendOutBoxMessageGetPath = '/OutBoxMessages/ResendOutBoxMessage';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendOutBoxMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendOutBoxMessageGet$Response(params?: OutBoxMessagesResendOutBoxMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outBoxMessagesResendOutBoxMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendOutBoxMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendOutBoxMessageGet(params?: OutBoxMessagesResendOutBoxMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outBoxMessagesResendOutBoxMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendOutBoxMessagePost()` */
  static readonly OutBoxMessagesResendOutBoxMessagePostPath = '/OutBoxMessages/ResendOutBoxMessage';

  /**
   * Resend OutBoxMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendOutBoxMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendOutBoxMessagePost$Response(params: OutBoxMessagesResendOutBoxMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesResendOutBoxMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Resend OutBoxMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendOutBoxMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendOutBoxMessagePost(params: OutBoxMessagesResendOutBoxMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesResendOutBoxMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendDynamicOutBoxMessageGet()` */
  static readonly OutBoxMessagesResendDynamicOutBoxMessageGetPath = '/OutBoxMessages/ResendDynamicOutBoxMessage';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendDynamicOutBoxMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendDynamicOutBoxMessageGet$Response(params?: OutBoxMessagesResendDynamicOutBoxMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outBoxMessagesResendDynamicOutBoxMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendDynamicOutBoxMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesResendDynamicOutBoxMessageGet(params?: OutBoxMessagesResendDynamicOutBoxMessageGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outBoxMessagesResendDynamicOutBoxMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesResendDynamicOutBoxMessagePost()` */
  static readonly OutBoxMessagesResendDynamicOutBoxMessagePostPath = '/OutBoxMessages/ResendDynamicOutBoxMessage';

  /**
   * Resend Dynamic OutBoxMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesResendDynamicOutBoxMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendDynamicOutBoxMessagePost$Response(params: OutBoxMessagesResendDynamicOutBoxMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesResendDynamicOutBoxMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Resend Dynamic OutBoxMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesResendDynamicOutBoxMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesResendDynamicOutBoxMessagePost(params: OutBoxMessagesResendDynamicOutBoxMessagePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesResendDynamicOutBoxMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesUpdateStatusGet()` */
  static readonly OutBoxMessagesUpdateStatusGetPath = '/OutBoxMessages/UpdateStatus/{id}';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesUpdateStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesUpdateStatusGet$Response(params: OutBoxMessagesUpdateStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outBoxMessagesUpdateStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesUpdateStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesUpdateStatusGet(params: OutBoxMessagesUpdateStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outBoxMessagesUpdateStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesUpdateStatusPut()` */
  static readonly OutBoxMessagesUpdateStatusPutPath = '/OutBoxMessages/UpdateStatus/{id}';

  /**
   * Update Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesUpdateStatusPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesUpdateStatusPut$Response(params: OutBoxMessagesUpdateStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesUpdateStatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesUpdateStatusPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesUpdateStatusPut(params: OutBoxMessagesUpdateStatusPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesUpdateStatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesUpdateIsShouldNotResendGet()` */
  static readonly OutBoxMessagesUpdateIsShouldNotResendGetPath = '/OutBoxMessages/UpdateIsShouldNotResend';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesUpdateIsShouldNotResendGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesUpdateIsShouldNotResendGet$Response(params?: OutBoxMessagesUpdateIsShouldNotResendGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outBoxMessagesUpdateIsShouldNotResendGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesUpdateIsShouldNotResendGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesUpdateIsShouldNotResendGet(params?: OutBoxMessagesUpdateIsShouldNotResendGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outBoxMessagesUpdateIsShouldNotResendGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesUpdateIsShouldNotResendPut()` */
  static readonly OutBoxMessagesUpdateIsShouldNotResendPutPath = '/OutBoxMessages/UpdateIsShouldNotResend';

  /**
   * Update Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesUpdateIsShouldNotResendPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesUpdateIsShouldNotResendPut$Response(params: OutBoxMessagesUpdateIsShouldNotResendPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesUpdateIsShouldNotResendPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesUpdateIsShouldNotResendPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesUpdateIsShouldNotResendPut(params: OutBoxMessagesUpdateIsShouldNotResendPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesUpdateIsShouldNotResendPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesUpdateDescription()` */
  static readonly OutBoxMessagesUpdateDescriptionPath = '/OutBoxMessages/UpdateDescription/{id}';

  /**
   * Update Description.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesUpdateDescription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesUpdateDescription$Response(params: OutBoxMessagesUpdateDescription$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesUpdateDescription(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Description.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesUpdateDescription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesUpdateDescription(params: OutBoxMessagesUpdateDescription$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesUpdateDescription$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutboxMessageTransactions()` */
  static readonly OutBoxMessagesGetOutboxMessageTransactionsPath = '/OutBoxMessages/{id}';

  /**
   * Get OutboxMessage Transactions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutboxMessageTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetOutboxMessageTransactions$Response(params: OutBoxMessagesGetOutboxMessageTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOutboxMessageTransactionsDto>> {
    return outBoxMessagesGetOutboxMessageTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutboxMessage Transactions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutboxMessageTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetOutboxMessageTransactions(params: OutBoxMessagesGetOutboxMessageTransactions$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOutboxMessageTransactionsDto> {
    return this.outBoxMessagesGetOutboxMessageTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOutboxMessageTransactionsDto>): CustomResultOfListOfGetOutboxMessageTransactionsDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutboxMessageByScheduledMessageId()` */
  static readonly OutBoxMessagesGetOutboxMessageByScheduledMessageIdPath = '/OutBoxMessages/GetOutboxMessageByScheduledMessageId';

  /**
   * Get OutboxMessage By ScheduledMessageId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutboxMessageByScheduledMessageId()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetOutboxMessageByScheduledMessageId$Response(params?: OutBoxMessagesGetOutboxMessageByScheduledMessageId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOutBoxByScheduledIdDto>> {
    return outBoxMessagesGetOutboxMessageByScheduledMessageId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutboxMessage By ScheduledMessageId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutboxMessageByScheduledMessageId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetOutboxMessageByScheduledMessageId(params?: OutBoxMessagesGetOutboxMessageByScheduledMessageId$Params, context?: HttpContext): Observable<CustomResultOfGetOutBoxByScheduledIdDto> {
    return this.outBoxMessagesGetOutboxMessageByScheduledMessageId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOutBoxByScheduledIdDto>): CustomResultOfGetOutBoxByScheduledIdDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetScheduledMessageStatisticsByOrganizationId()` */
  static readonly OutBoxMessagesGetScheduledMessageStatisticsByOrganizationIdPath = '/OutBoxMessages/GetScheduledMessageStatisticsByOrganizationId';

  /**
   * Get Scheduled Message Statistics By OrganizationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetScheduledMessageStatisticsByOrganizationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetScheduledMessageStatisticsByOrganizationId$Response(params: OutBoxMessagesGetScheduledMessageStatisticsByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSendTypeStatisticsDto>> {
    return outBoxMessagesGetScheduledMessageStatisticsByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Scheduled Message Statistics By OrganizationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetScheduledMessageStatisticsByOrganizationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetScheduledMessageStatisticsByOrganizationId(params: OutBoxMessagesGetScheduledMessageStatisticsByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfSendTypeStatisticsDto> {
    return this.outBoxMessagesGetScheduledMessageStatisticsByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSendTypeStatisticsDto>): CustomResultOfListOfSendTypeStatisticsDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutBoxStatisticsByDateTime()` */
  static readonly OutBoxMessagesGetOutBoxStatisticsByDateTimePath = '/OutBoxMessages/GetOutBoxStatisticsByDateTime';

  /**
   * Get OutBox Statistics By DateTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutBoxStatisticsByDateTime()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxStatisticsByDateTime$Response(params: OutBoxMessagesGetOutBoxStatisticsByDateTime$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSendTypeStatisticsByDateTimeDto>> {
    return outBoxMessagesGetOutBoxStatisticsByDateTime(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBox Statistics By DateTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutBoxStatisticsByDateTime$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxStatisticsByDateTime(params: OutBoxMessagesGetOutBoxStatisticsByDateTime$Params, context?: HttpContext): Observable<CustomResultOfListOfSendTypeStatisticsByDateTimeDto> {
    return this.outBoxMessagesGetOutBoxStatisticsByDateTime$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSendTypeStatisticsByDateTimeDto>): CustomResultOfListOfSendTypeStatisticsByDateTimeDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutBoxMessageAndBulkRecipientsById()` */
  static readonly OutBoxMessagesGetOutBoxMessageAndBulkRecipientsByIdPath = '/OutBoxMessages/GetOutBoxMessageAndBulkRecipientsById';

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutBoxMessageAndBulkRecipientsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetOutBoxMessageAndBulkRecipientsById$Response(params?: OutBoxMessagesGetOutBoxMessageAndBulkRecipientsById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOutBoxMessageAndBulkRecipientsByIdDto>> {
    return outBoxMessagesGetOutBoxMessageAndBulkRecipientsById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage ById for detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutBoxMessageAndBulkRecipientsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetOutBoxMessageAndBulkRecipientsById(params?: OutBoxMessagesGetOutBoxMessageAndBulkRecipientsById$Params, context?: HttpContext): Observable<CustomResultOfGetOutBoxMessageAndBulkRecipientsByIdDto> {
    return this.outBoxMessagesGetOutBoxMessageAndBulkRecipientsById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOutBoxMessageAndBulkRecipientsByIdDto>): CustomResultOfGetOutBoxMessageAndBulkRecipientsByIdDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesDeleteOutBoxMessage()` */
  static readonly OutBoxMessagesDeleteOutBoxMessagePath = '/OutBoxMessages/DeleteOutBoxMessage';

  /**
   * Delete OutBox Message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesDeleteOutBoxMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesDeleteOutBoxMessage$Response(params: OutBoxMessagesDeleteOutBoxMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesDeleteOutBoxMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete OutBox Message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesDeleteOutBoxMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesDeleteOutBoxMessage(params: OutBoxMessagesDeleteOutBoxMessage$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesDeleteOutBoxMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesDeleteOutBoxMessagesByList()` */
  static readonly OutBoxMessagesDeleteOutBoxMessagesByListPath = '/OutBoxMessages/DeleteOutBoxMessagesByList';

  /**
   * Delete OutBox Messages By List Of ScheduledMessage Ids.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesDeleteOutBoxMessagesByList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesDeleteOutBoxMessagesByList$Response(params: OutBoxMessagesDeleteOutBoxMessagesByList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesDeleteOutBoxMessagesByList(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete OutBox Messages By List Of ScheduledMessage Ids.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesDeleteOutBoxMessagesByList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesDeleteOutBoxMessagesByList(params: OutBoxMessagesDeleteOutBoxMessagesByList$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesDeleteOutBoxMessagesByList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutBoxMessageDailyStatistics()` */
  static readonly OutBoxMessagesGetOutBoxMessageDailyStatisticsPath = '/OutBoxMessages/GetOutBoxMessageDailyStatistics';

  /**
   * GetOutBoxMessageDailyStatistics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutBoxMessageDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxMessageDailyStatistics$Response(params: OutBoxMessagesGetOutBoxMessageDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfOutBoxMessagesStatisticsDto>> {
    return outBoxMessagesGetOutBoxMessageDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * GetOutBoxMessageDailyStatistics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutBoxMessageDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxMessageDailyStatistics(params: OutBoxMessagesGetOutBoxMessageDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfOutBoxMessagesStatisticsDto> {
    return this.outBoxMessagesGetOutBoxMessageDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfOutBoxMessagesStatisticsDto>): CustomResultOfListOfOutBoxMessagesStatisticsDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics()` */
  static readonly OutBoxMessagesGetOutBoxMessageCategorizedDailyStatisticsPath = '/OutBoxMessages/GetOutBoxMessageCategorizedDailyStatistics';

  /**
   * Get OutBox Message Categorized Daily Statistics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics$Response(params: OutBoxMessagesGetOutBoxMessageCategorizedDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfOutBoxMessageDailyCategorizedStatisticsDto>> {
    return outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OutBox Message Categorized Daily Statistics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics(params: OutBoxMessagesGetOutBoxMessageCategorizedDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfOutBoxMessageDailyCategorizedStatisticsDto> {
    return this.outBoxMessagesGetOutBoxMessageCategorizedDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfOutBoxMessageDailyCategorizedStatisticsDto>): CustomResultOfListOfOutBoxMessageDailyCategorizedStatisticsDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetLastLimitedCurrentUserOutboxMessages()` */
  static readonly OutBoxMessagesGetLastLimitedCurrentUserOutboxMessagesPath = '/OutBoxMessages/GetLastLimitedCurrentUserOutboxMessages';

  /**
   * دریافت آخرین کمپین های کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetLastLimitedCurrentUserOutboxMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetLastLimitedCurrentUserOutboxMessages$Response(params?: OutBoxMessagesGetLastLimitedCurrentUserOutboxMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetLastLimitedCurrentUserOutboxMessagesDto>> {
    return outBoxMessagesGetLastLimitedCurrentUserOutboxMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آخرین کمپین های کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetLastLimitedCurrentUserOutboxMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outBoxMessagesGetLastLimitedCurrentUserOutboxMessages(params?: OutBoxMessagesGetLastLimitedCurrentUserOutboxMessages$Params, context?: HttpContext): Observable<CustomResultOfListOfGetLastLimitedCurrentUserOutboxMessagesDto> {
    return this.outBoxMessagesGetLastLimitedCurrentUserOutboxMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetLastLimitedCurrentUserOutboxMessagesDto>): CustomResultOfListOfGetLastLimitedCurrentUserOutboxMessagesDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesGetResendCalculation()` */
  static readonly OutBoxMessagesGetResendCalculationPath = '/OutBoxMessages/GetResendCalculation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesGetResendCalculation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetResendCalculation$Response(params: OutBoxMessagesGetResendCalculation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetResendCalculationDto>> {
    return outBoxMessagesGetResendCalculation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesGetResendCalculation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesGetResendCalculation(params: OutBoxMessagesGetResendCalculation$Params, context?: HttpContext): Observable<CustomResultOfGetResendCalculationDto> {
    return this.outBoxMessagesGetResendCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetResendCalculationDto>): CustomResultOfGetResendCalculationDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesCheckIsResendByAutomaticResend()` */
  static readonly OutBoxMessagesCheckIsResendByAutomaticResendPath = '/OutBoxMessages/CheckIsResendByAutomaticResend';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesCheckIsResendByAutomaticResend()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesCheckIsResendByAutomaticResend$Response(params: OutBoxMessagesCheckIsResendByAutomaticResend$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfCheckIsResendByAutomaticResendDto>> {
    return outBoxMessagesCheckIsResendByAutomaticResend(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesCheckIsResendByAutomaticResend$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesCheckIsResendByAutomaticResend(params: OutBoxMessagesCheckIsResendByAutomaticResend$Params, context?: HttpContext): Observable<CustomResultOfCheckIsResendByAutomaticResendDto> {
    return this.outBoxMessagesCheckIsResendByAutomaticResend$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfCheckIsResendByAutomaticResendDto>): CustomResultOfCheckIsResendByAutomaticResendDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend()` */
  static readonly OutBoxMessagesCheckOutboxMessagesIsResendByAutomaticResendPath = '/OutBoxMessages/CheckOutboxMessagesIsResendByAutomaticResend';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend$Response(params: OutBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfCheckOutboxMessagesIsResendByAutomaticResendDto>> {
    return outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend(params: OutBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend$Params, context?: HttpContext): Observable<CustomResultOfCheckOutboxMessagesIsResendByAutomaticResendDto> {
    return this.outBoxMessagesCheckOutboxMessagesIsResendByAutomaticResend$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfCheckOutboxMessagesIsResendByAutomaticResendDto>): CustomResultOfCheckOutboxMessagesIsResendByAutomaticResendDto => r.body)
    );
  }

  /** Path part for operation `outBoxMessagesStopSendingOutboxMessage()` */
  static readonly OutBoxMessagesStopSendingOutboxMessagePath = '/OutBoxMessages/StopSendingOutboxMessage';

  /**
   * توقف ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outBoxMessagesStopSendingOutboxMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesStopSendingOutboxMessage$Response(params: OutBoxMessagesStopSendingOutboxMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outBoxMessagesStopSendingOutboxMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * توقف ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outBoxMessagesStopSendingOutboxMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outBoxMessagesStopSendingOutboxMessage(params: OutBoxMessagesStopSendingOutboxMessage$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outBoxMessagesStopSendingOutboxMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
